<template>
  <div style="width: 100%">
    <div style="width: 100%">
      <el-steps
        :active="active"
        finish-status="success"
        align-center
        style="width: 100%"
      >
        <el-step title="Shipping From"></el-step>
        <el-step title="Shipping To"></el-step>
        <el-step title="Package Detail"></el-step>
        <!-- <el-step title="Additional Info"></el-step> -->
        <el-step title="Review"></el-step>
      </el-steps>
    </div>
    <div>
      <div class="step1" v-show="active === 0">
        <!-- step1 - 1 -->
        <div class="ship-to" v-show="selectStore">
          <div>
            <el-card>
              <div
                style="
                  width: 100%;
                  display: flex;
                  flex-direction: row;
                  padding: 12px 12px;
                  font-size: 16px;
                  font-weight: bold;
                  border-bottom: 1px solid #e0e0e0;
                  box-sizing: border-box;
                "
              >
                Select a Brother58 store
              </div>

              <div
                v-if="stores && stores.length > 0"
                style="
                  width: 100%;
                  padding: 30px 12px;
                  box-sizing: border-box;
                  position: relative;
                "
              >
                <el-select
                  v-model="selectedStoreIndex"
                  placeholder="Select a Brother58 store"
                  style="
                    width: 100%;
                    font-weight: bold;
                    border: 2px solid #fa0;
                    border-radius: 10px;
                  "
                >
                  <el-option
                    v-for="(item, index) in stores"
                    :key="index"
                    :label="`${item.mapIndex} - ${item.name}`"
                    :value="index"
                  >
                    <span style="float: left"
                      ><span style="color: red; font-weight: 700">{{
                        item.mapIndex
                      }}</span>
                      {{ item.name }}</span
                    >
                    <span
                      style="float: right; color: #8492a6; font-size: 13px"
                      >{{ item.addressStr }}</span
                    >
                  </el-option>
                </el-select>

                <div
                  style="
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    padding: 0;
                    margin-top: 12px;
                    box-sizing: border-box;
                  "
                >
                  <el-button
                    type="primary"
                    @click="selectStore = false"
                    :disabled="!selectedBrother58Store.name"
                    >Next</el-button
                  >
                </div>
                <!-- map -->
                <div class="map" style="width: 100%; margin-top: 30px">
                  <googlemaps-map
                    style="height: 500px"
                    ref="map"
                    class="map"
                    :center.sync="center"
                    :zoom.sync="zoom"
                  >
                    <!-- User Position -->
                    <googlemaps-user-position
                      @update:position="setUserPosition"
                    />

                    <googlemaps-marker
                      v-for="(marker, index) of stores"
                      :key="index"
                      :label="{
                        fontFamily: 'Material Icons',
                        color: 'white',
                        fontSize: '20px',
                        text:
                          marker.mapIndex === selectedBrother58Store.mapIndex
                            ? 'done_outline'
                            : marker.mapIndex,
                      }"
                      :position="marker.mapPosition"
                      @click="selectMarker(index)"
                    />
                  </googlemaps-map>
                </div>
              </div>
            </el-card>
          </div>
        </div>

        <!-- step1 - 2 -->
        <div class="step1 step1-2" v-show="!selectStore">
          <div class="from-shop">
            <el-card>
              <div
                style="
                  width: 100%;
                  display: flex;
                  flex-direction: row;
                  padding: 12px 12px;
                  border-bottom: 1px solid #e0e0e0;
                  box-sizing: border-box;
                "
                @click="shipFrom = 'Brother58 Address'"
              >
                <el-radio
                  v-model="shipFrom"
                  label="Brother58 Address"
                  style="font-weight: bold; color: #757575"
                  >Drop off by yourself</el-radio
                >
              </div>
              <div
                style="
                  width: 100%;
                  display: flex;
                  flex-direction: column;
                  padding: 32px 12px;
                  box-sizing: border-box;
                "
              >
                <el-form
                  :disabled="shipFrom !== 'Brother58 Address'"
                  :model="userContact"
                  ref="step1FormContactOnly"
                >
                  <el-form-item label="Phone Number" prop="phone">
                    <el-input
                      placeholder="Please enter your phone number if you prefer phone contact"
                      type="number"
                      v-model="userContact.phone"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Email" prop="email">
                    <el-input
                      placeholder="Please enter your email if you prefer email contact"
                      v-model="userContact.email"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-form>
                <span
                  style="width: 100%; text-align: left; padding-left: 34px"
                  >{{ selectedBrother58Store.name }}</span
                >
                <span
                  style="
                    width: 100%;
                    text-align: left;
                    padding-top: 8px;
                    display: flex;
                    align-items: center;
                    padding-top: 12px;
                  "
                  ><i class="material-icons" style="color: #333">phone</i
                  >{{ selectedBrother58Store.phoneStr }}</span
                >
                <span
                  style="
                    width: 100%;
                    text-align: left;
                    padding-top: 8px;
                    display: flex;
                    align-items: center;
                    padding-top: 12px;
                  "
                  ><i class="material-icons" style="color: #333">location_on</i
                  >{{ selectedBrother58Store.addressStr }}</span
                >
              </div>
              <div
                style="
                  width: 100%;
                  display: flex;
                  flex-direction: row;
                  padding: 0px 12px;
                  box-sizing: border-box;
                "
              >
                <el-button
                  type="info"
                  icon="el-icon-arrow-left"
                  plain
                  @click="selectStore = true"
                  >Back</el-button
                >
                <el-button
                  type="primary"
                  plain
                  :disabled="shipFrom !== 'Brother58 Address'"
                  @click="toStep2"
                  >Next <i class="el-icon-arrow-right el-icon-right"></i
                ></el-button>
              </div>
            </el-card>
          </div>
          <div class="from-home">
            <el-card>
              <div
                style="
                  width: 100%;
                  display: flex;
                  flex-direction: row;
                  padding: 12px 12px;
                  border-bottom: 1px solid #e0e0e0;
                  box-sizing: border-box;
                "
                @click="shipFrom = 'Customize Address'"
              >
                <el-radio
                  v-model="shipFrom"
                  label="Customize Address"
                  style="font-weight: bold; color: #757575"
                  >We pick up package at your place</el-radio
                >
              </div>
              <div
                style="
                  width: 100%;
                  padding: 12px 12px;
                  box-sizing: border-box;
                  position: relative;
                "
              >
                <el-form
                  :rules="rules"
                  :disabled="shipFrom === 'Brother58 Address'"
                  :model="customSendAddress"
                  ref="step1Form"
                >
                  <el-form-item label="Name" prop="name">
                    <el-input
                      placeholder="Enter Sender's Name"
                      v-model="customSendAddress.name"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Phone Number" prop="phone">
                    <el-input
                      placeholder="Enter Sender's Phone Number"
                      type="number"
                      v-model="customSendAddress.phone"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Address" prop="address1">
                    <el-input
                      placeholder="Enter Sender's Address"
                      v-model="customSendAddress.address1"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Apt / Suite #" prop="address2">
                    <el-input
                      placeholder="Enter Apt/Suite #"
                      v-model="customSendAddress.address2"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="City" prop="city">
                    <el-input
                      placeholder="Enter Sender's City"
                      v-model="customSendAddress.city"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="State" prop="state">
                    <el-input
                      placeholder="Enter Sender's State"
                      v-model="customSendAddress.state"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Postal Code" prop="postal">
                    <el-input
                      placeholder="Enter Sender's Postal Code"
                      type="number"
                      v-model="customSendAddress.postal"
                      clearable
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Country" prop="country">
                    <el-input
                      placeholder="Enter Sender's Country"
                      v-model="customSendAddress.country"
                      disabled
                    ></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div
                style="
                  width: 100%;
                  display: flex;
                  flex-direction: row;
                  padding: 0px 12px;
                  box-sizing: border-box;
                "
              >
                <el-button
                  type="info"
                  icon="el-icon-arrow-left"
                  plain
                  @click="selectStore = true"
                  >Back</el-button
                >
                <el-button
                  type="primary"
                  plain
                  :disabled="shipFrom === 'Brother58 Address'"
                  @click="toStep2"
                  >Next <i class="el-icon-arrow-right el-icon-right"></i
                ></el-button>
              </div>
            </el-card>
          </div>
        </div>
      </div>
      <div class="step2" v-show="active === 1">
        <div class="ship-to">
          <el-card>
            <div
              style="
                width: 100%;
                display: flex;
                flex-direction: row;
                padding: 12px 12px;
                font-size: 16px;
                font-weight: bold;
                border-bottom: 1px solid #e0e0e0;
                box-sizing: border-box;
              "
            >
              Shipping To
            </div>
            <div style="width: 100%">
              <el-button
                @click="showAddressBook = true"
                type="primary"
                style="width: 100%"
                >Select from address book.</el-button
              >
            </div>
            <div
              style="
                width: 100%;
                padding: 12px 12px;
                box-sizing: border-box;
                position: relative;
              "
            >
              <el-form
                :rules="rulesReceiver"
                :model="receiveInfo"
                ref="step2Form"
              >
                <el-form-item label="Name" prop="name">
                  <el-input
                    placeholder="Enter Recipient's Name"
                    v-model="receiveInfo.name"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="Phone Number" prop="phone">
                  <el-input
                    placeholder="Enter Recipient's Phone Number"
                    type="number"
                    v-model="receiveInfo.phone"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="ID Number" prop="ID">
                  <el-input
                    placeholder="Enter Recipient's ID Number"
                    v-model="receiveInfo.ID"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="Region" prop="province">
                  <el-row>
                    <el-col :span="24" style="display: flex">
                      <el-cascader
                        :options="locationOption"
                        v-model="selectedRegion"
                        placeholder="Province / City / District"
                        style="width: 100%"
                      ></el-cascader>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="Address" prop="addressInfo">
                  <el-input
                    placeholder="Enter Recipient's Address Info"
                    v-model="receiveInfo.addressInfo"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="Postal Code" prop="postal">
                  <el-input
                    placeholder="Enter Recipient's Postal Code"
                    type="number"
                    v-model="receiveInfo.postal"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item label="Country" prop="country">
                  <el-input
                    placeholder="Enter Recipient's Country"
                    v-model="receiveInfo.country"
                    disabled
                  ></el-input>
                </el-form-item>
                <el-form-item label="Save to Address Book">
                  <el-checkbox v-model="saveToAddressBook.save"
                    >Save to my address book.</el-checkbox
                  >
                  <el-input
                    v-model="saveToAddressBook.alias"
                    :disabled="!saveToAddressBook.save"
                    placeholder="Enter an alias/name for this address"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div
              style="
                width: 100%;
                display: flex;
                flex-direction: row;
                padding: 0px 12px;
                box-sizing: border-box;
              "
            >
              <el-button
                type="info"
                icon="el-icon-arrow-left"
                plain
                @click="toStep1"
                >Back</el-button
              >
              <el-button type="primary" plain @click="toStep3"
                >Next <i class="el-icon-arrow-right el-icon-right"></i
              ></el-button>
            </div>
          </el-card>
        </div>
      </div>
      <div class="step3" v-show="active === 2">
        <div class="pack-detail">
          <el-card>
            <div
              style="
                width: 100%;
                display: flex;
                flex-direction: row;
                padding: 12px 12px;
                font-size: 16px;
                font-weight: bold;
                border-bottom: 1px solid #e0e0e0;
                box-sizing: border-box;
              "
            >
              Package Detail
            </div>
            <div
              style="
                width: 100%;
                padding: 12px 12px;
                box-sizing: border-box;
                position: relative;
              "
            >
              <el-form :rules="rulesItems" :model="packDetail" ref="step3Form">
                <!-- <el-form-item label="Weight (LB)" prop="weight">
                    <el-input placeholder="Estimate your package weight(LB)" v-model="packDetail.weight" clearable></el-input>
                  </el-form-item> -->
                <el-form-item
                  :label="'Item ' + (index + 1)"
                  v-for="(item, index) in packDetail.items"
                  :key="item.key"
                >
                  <el-row style="display: flex; justify-content: space-between">
                    <el-col :span="14">
                      <el-form-item style="margin-bottom: 12px; display: flex">
                        <el-select
                          placeholder="Select from category"
                          v-model="item.category"
                        >
                          <el-option
                            v-for="item in categoryOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="4">
                      <el-button
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        @click="deleteItem(item)"
                        size="small"
                      ></el-button>
                    </el-col>
                  </el-row>
                  <el-form-item v-show="item.category">
                    <el-input
                      placeholder="Enter item name with brand"
                      v-model="item.name"
                    >
                      <template slot="prepend">Name w/ Brand</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item v-show="item.category">
                    <el-input
                      placeholder="Enter item quantity"
                      type="number"
                      v-model="item.qty"
                    >
                      <template slot="prepend">Qty.</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item v-show="item.category">
                    <el-input
                      placeholder="Enter item price"
                      type="number"
                      v-model="item.price"
                    >
                      <template slot="prepend">Unit Price $</template>
                    </el-input>
                  </el-form-item>
                  <el-form-item v-show="item.category">
                    <el-input
                      placeholder="Enter the total weight for this item"
                      type="number"
                      v-model="item.weight"
                    >
                      <template slot="prepend">Item Total Weight / LB</template>
                      <!-- <template slot="append">
                            <el-tooltip content="Total weight for this item, will be used to estimate your shipping fee." placement="top">
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </template> -->
                    </el-input>
                  </el-form-item>
                  <el-form-item v-show="categoryRule[item.category]">
                    <el-input
                      placeholder="Enter item specification"
                      v-model="item.spec"
                    >
                      <template slot="prepend">Spec.</template>
                      <el-select
                        v-model="item.specUnit"
                        slot="append"
                        placeholder="Select"
                        class="specSelect"
                      >
                        <el-option label="克 g" value="克 g"></el-option>
                        <el-option label="毫升 mL" value="毫升 mL"></el-option>
                        <el-option
                          label="粒 tablets or capsules"
                          value="粒 tablets or capsules"
                        ></el-option>
                        <el-option label="盎司 oz" value="盎司 oz"></el-option>
                        <el-option label="Other" value="Other"></el-option>
                      </el-select>
                    </el-input>
                  </el-form-item>
                </el-form-item>
                <div
                  style="
                    width: 100%;
                    margin-top: 16px;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: flex-end;
                  "
                >
                  <el-button
                    icon="el-icon-plus"
                    circle
                    @click="addItem"
                  ></el-button>
                </div>
              </el-form>
              <div
                style="
                  width: 100%;
                  text-align: left;
                  color: #f56c6c;
                  font-size: 14px;
                "
              >
                {{ warningTxt }}
              </div>
            </div>
            <div
              style="
                width: 100%;
                display: flex;
                flex-direction: row;
                padding: 0px 12px;
                box-sizing: border-box;
              "
            >
              <el-button
                type="info"
                icon="el-icon-arrow-left"
                plain
                @click="active = 1"
                >Back</el-button
              >
              <el-button type="primary" plain @click="toStep4"
                >Next <i class="el-icon-arrow-right el-icon-right"></i
              ></el-button>
            </div>
          </el-card>
        </div>
      </div>
      <div class="step4" v-show="active === 3">
        <div class="add-info">
          <el-card>
            <div
              style="
                width: 100%;
                display: flex;
                flex-direction: row;
                padding: 12px 12px;
                font-size: 16px;
                font-weight: bold;
                border-bottom: 1px solid #e0e0e0;
                box-sizing: border-box;
              "
            >
              Additional Info
            </div>
            <div
              style="
                width: 100%;
                padding: 12px 12px;
                box-sizing: border-box;
                position: relative;
              "
            >
              <el-form :rules="rulesAddInfo" :model="addInfo" ref="step4Form">
                <el-form-item
                  label="是否需要包装 Packing box by store?"
                  prop="packing"
                  style="
                    display: flex;
                    flex-direction: column;
                    text-align: left;
                  "
                >
                  <div @click="selectPacking(true)">
                    <el-radio
                      v-model="addInfo.packing"
                      label="是 Yes (包税模式运费较高，B2C运费无影响)"
                    ></el-radio>
                  </div>
                  <div @click="selectPacking(false)">
                    <el-radio
                      v-model="addInfo.packing"
                      label="否 No (包税模式运费较低，B2C运费无影响)"
                    ></el-radio>
                  </div>
                </el-form-item>
                <el-form-item
                  label="选择您需要的保费 Insurance Fee"
                  prop="insurance"
                  style="
                    display: flex;
                    flex-direction: column;
                    text-align: left;
                  "
                >
                  <div @click="insuranceFee(0)">
                    <el-radio
                      v-model="addInfo.insurance"
                      label="Free（免费），如包裹丢失最高赔付$100"
                    ></el-radio>
                  </div>
                  <div @click="insuranceFee(5)">
                    <el-radio
                      v-model="addInfo.insurance"
                      label="$5，如包裹丢失最高赔付$200"
                    ></el-radio>
                  </div>
                  <div @click="insuranceFee(10)">
                    <el-radio
                      v-model="addInfo.insurance"
                      label="$10，如包裹丢失最高赔付$300"
                    ></el-radio>
                  </div>
                  <div @click="insuranceFee(15)">
                    <el-radio
                      v-model="addInfo.insurance"
                      label="$15，如包裹丢失最高赔付$400"
                    ></el-radio>
                  </div>
                </el-form-item>
                <el-form-item
                  label="请选择税费模式"
                  prop="shippingMethod"
                  style="
                    display: flex;
                    flex-direction: column;
                    text-align: left;
                  "
                >
                  <div>
                    <div @click="shippingMethod('b2c')">
                      <el-radio
                        v-model="addInfo.shippingMethod"
                        label="b2c"
                      ></el-radio>
                      <div style="margin-left: 24px">
                        <div>Shipping ETA: Standard</div>
                        <div>Tax: $ {{ shippingFee.tax }}</div>
                        <div>Shipping Fee: $ {{ shippingFee.b2c }}</div>
                        <div>
                          Packing Method: $
                          {{ packData.addInfo.packaged ? "打包" : "不打包" }}
                        </div>
                        <div>
                          Insurance Fee: $ {{ packData.addInfo.insuranceFee }}
                        </div>
                        <div>Total: $ {{ b2cTotal() }}</div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div @click="shippingMethod('noTax')">
                      <el-radio
                        v-model="addInfo.shippingMethod"
                        label="noTax"
                      ></el-radio>
                      <div style="margin-left: 24px">
                        <div>Shipping ETA: Standard</div>
                        <div>Tax: $ 0.00</div>
                        <!-- packaged -->
                        <div v-if="addInfo.packaged">
                          Shipping Fee(Packaged): $ {{ shippingFee.packaged }}
                        </div>
                        <!-- unpackaged -->
                        <div v-if="!addInfo.packaged">
                          Shipping Fee(Unpackaged): $
                          {{ shippingFee.unpackaged }}
                        </div>
                        <div>
                          Packing Method: $
                          {{ packData.addInfo.packaged ? "打包" : "不打包" }}
                        </div>
                        <div>
                          Insurance Fee: $ {{ packData.addInfo.insuranceFee }}
                        </div>
                        <div>Total: $ {{ noTaxTotal() }}</div>
                      </div>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="留言 Remark" prop="remark">
                  <el-input
                    placeholder="Leave a remark"
                    v-model="addInfo.remark"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div
              style="
                width: 100%;
                display: flex;
                flex-direction: row;
                padding: 0px 12px;
                box-sizing: border-box;
              "
            >
              <el-button
                type="info"
                icon="el-icon-arrow-left"
                plain
                @click="active = 2"
                >Back</el-button
              >
              <el-button type="primary" plain @click="toStep5"
                >Next <i class="el-icon-arrow-right el-icon-right"></i
              ></el-button>
            </div>
          </el-card>
        </div>
      </div>
      <div class="step5" v-show="active === 4">
        <div class="confirm-info">
          <el-card>
            <div
              style="
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: flex-end;
                justify-content: space-between;
                padding: 12px 12px;
                font-size: 16px;
                font-weight: bold;
                border-bottom: 1px solid #e0e0e0;
                box-sizing: border-box;
              "
            >
              Shipping From<el-button
                type="primary"
                size="small"
                icon="el-icon-edit"
                circle
                @click="active = 0"
              ></el-button>
            </div>
            <div
              style="
                width: 100%;
                padding: 12px 12px;
                box-sizing: border-box;
                position: relative;
              "
            >
              <div
                style="
                  font-size: 15px;
                  font-weight: 600;
                  text-align: left;
                  color: rgba(0, 0, 0, 0.95);
                "
              >
                {{ packData.shipFrom.name }}
              </div>
              <div
                style="
                  font-size: 15px;
                  text-align: left;
                  margin-top: 16px;
                  display: flex;
                  color: rgba(0, 0, 0, 0.85);
                "
              >
                <span
                  style="
                    color: rgba(0, 0, 0, 0.65);
                    width: 52px;
                    font-size: 14px;
                  "
                  >Phone</span
                >
                {{ packData.shipFrom.phone }}
              </div>
              <div
                style="
                  font-size: 15px;
                  text-align: left;
                  margin-top: 5px;
                  display: flex;
                  color: rgba(0, 0, 0, 0.7);
                "
              >
                <div
                  style="
                    width: 65px;
                    color: rgba(0, 0, 0, 0.65);
                    font-size: 14px;
                  "
                >
                  Address
                </div>
                {{ packData.shipFrom.address1 }}
                {{ packData.shipFrom.address2 }}
              </div>
              <div
                style="
                  font-size: 15px;
                  text-align: left;
                  color: rgba(0, 0, 0, 0.7);
                  padding-left: 65px;
                "
              >
                {{ packData.shipFrom.city }}, {{ packData.shipFrom.state }},
                {{ packData.shipFrom.postal }}
              </div>
              <div
                style="
                  font-size: 15px;
                  text-align: left;
                  color: rgba(0, 0, 0, 0.7);
                  padding-left: 65px;
                "
              >
                {{ packData.shipFrom.country }}
              </div>
            </div>
          </el-card>
          <el-card style="margin-top: 24px">
            <div
              style="
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: flex-end;
                justify-content: space-between;
                padding: 12px 12px;
                font-size: 16px;
                font-weight: bold;
                border-bottom: 1px solid #e0e0e0;
                box-sizing: border-box;
              "
            >
              Shipping To<el-button
                type="primary"
                size="small"
                icon="el-icon-edit"
                circle
                @click="active = 1"
              ></el-button>
            </div>
            <div
              style="
                width: 100%;
                padding: 12px 12px;
                box-sizing: border-box;
                position: relative;
              "
            >
              <div
                style="
                  font-size: 15px;
                  font-weight: 600;
                  text-align: left;
                  color: rgba(0, 0, 0, 0.95);
                "
              >
                {{ packData.shipTo.name }}
              </div>
              <div
                style="
                  font-size: 15px;
                  text-align: left;
                  margin-top: 16px;
                  display: flex;
                  color: rgba(0, 0, 0, 0.85);
                "
              >
                <span
                  style="
                    color: rgba(0, 0, 0, 0.65);
                    width: 25px;
                    font-size: 14px;
                  "
                  >ID</span
                >{{ packData.shipTo.ID }}
              </div>
              <div
                style="
                  font-size: 15px;
                  text-align: left;
                  margin-top: 5px;
                  display: flex;
                  color: rgba(0, 0, 0, 0.85);
                "
              >
                <span
                  style="
                    color: rgba(0, 0, 0, 0.65);
                    width: 52px;
                    font-size: 14px;
                  "
                  >Phone</span
                >{{ packData.shipTo.phone }}
              </div>
              <div
                style="
                  font-size: 15px;
                  text-align: left;
                  margin-top: 5px;
                  display: flex;
                  color: rgba(0, 0, 0, 0.7);
                  word-wrap: break-word;
                "
              >
                <div
                  style="
                    width: 65px;
                    color: rgba(0, 0, 0, 0.65);
                    font-size: 14px;
                  "
                >
                  Address
                </div>
                {{ packData.shipTo.addressInfo }}
              </div>
              <div
                style="
                  font-size: 15px;
                  text-align: left;
                  color: rgba(0, 0, 0, 0.7);
                  padding-left: 65px;
                "
              >
                {{ packData.shipTo.province }}, {{ packData.shipTo.city }},
                {{ packData.shipTo.district }}
              </div>
              <div
                style="
                  font-size: 15px;
                  text-align: left;
                  color: rgba(0, 0, 0, 0.7);
                  padding-left: 65px;
                "
              >
                {{ packData.shipTo.postal }}
              </div>
              <div
                style="
                  font-size: 15px;
                  text-align: left;
                  color: rgba(0, 0, 0, 0.7);
                  padding-left: 65px;
                "
              >
                {{ packData.shipTo.country }}
              </div>
            </div>
          </el-card>
          <el-card style="margin-top: 24px">
            <div
              style="
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: flex-end;
                justify-content: space-between;
                padding: 12px 12px;
                font-size: 16px;
                font-weight: bold;
                border-bottom: 1px solid #e0e0e0;
                box-sizing: border-box;
              "
            >
              Package Detail<el-button
                type="primary"
                size="small"
                icon="el-icon-edit"
                circle
                @click="active = 2"
              ></el-button>
            </div>
            <div
              style="
                width: 100%;
                padding: 12px 12px;
                box-sizing: border-box;
                position: relative;
              "
            >
              <!-- <div style="font-size: 15px;text-align:left;color:rgba(0,0,0,0.85);display:flex;"><span style="color:rgba(0,0,0,0.65);width:50px;font-size:14px">Weight</span>{{ packData.packDetail.weight }} LB</div> -->
              <div
                style="
                  font-size: 15px;
                  text-align: left;
                  font-weight: bold;
                  margin-top: 8px;
                  display: flex;
                  color: rgba(0, 0, 0, 0.85);
                "
              >
                Items
              </div>
              <div
                v-for="(item, index) in packData.packDetail.items"
                v-bind:key="item.key"
                style="
                  font-size: 15px;
                  text-align: left;
                  margin-top: 6px;
                  display: flex;
                  color: rgba(0, 0, 0, 0.8);
                "
              >
                <div style="display: flex; flex-direction: column">
                  <div
                    style="
                      display: flex;
                      font-size: 15px;
                      text-align: left;
                      color: rgba(0, 0, 0, 0.95);
                    "
                  >
                    <div
                      style="
                        width: 50px;
                        font-size: 14px;
                        color: rgba(0, 0, 0, 0.65);
                      "
                    >
                      Item {{ index + 1 }}
                    </div>
                    {{ item.name }}
                  </div>
                  <div
                    style="
                      font-size: 15px;
                      text-align: left;
                      color: rgba(0, 0, 0, 0.85);
                      display: flex;
                      padding-left: 50px;
                      margin-top: 2px;
                      word-wrap: break-word;
                    "
                  >
                    <span
                      style="
                        color: rgba(0, 0, 0, 0.65);
                        font-size: 14px;
                        width: 70px;
                      "
                      >Category</span
                    >{{ item.category }}
                  </div>
                  <div
                    style="
                      font-size: 15px;
                      text-align: left;
                      color: rgba(0, 0, 0, 0.85);
                      display: flex;
                      padding-left: 50px;
                      margin-top: 2px;
                    "
                  >
                    <span
                      style="
                        color: rgba(0, 0, 0, 0.65);
                        font-size: 14px;
                        width: 70px;
                      "
                      >Price </span
                    >$ {{ item.price }}
                  </div>
                  <div
                    style="
                      font-size: 15px;
                      text-align: left;
                      color: rgba(0, 0, 0, 0.85);
                      display: flex;
                      padding-left: 50px;
                      margin-top: 2px;
                    "
                  >
                    <span
                      style="
                        color: rgba(0, 0, 0, 0.65);
                        font-size: 14px;
                        width: 70px;
                      "
                      >Qty. </span
                    >{{ item.qty }}
                  </div>
                  <div
                    style="
                      font-size: 15px;
                      text-align: left;
                      color: rgba(0, 0, 0, 0.85);
                      display: flex;
                      padding-left: 50px;
                      margin-top: 2px;
                    "
                  >
                    <span
                      style="
                        color: rgba(0, 0, 0, 0.65);
                        font-size: 14px;
                        width: 70px;
                      "
                      >Weight </span
                    >{{ item.weight }} LB
                  </div>
                  <div
                    style="
                      font-size: 15px;
                      text-align: left;
                      color: rgba(0, 0, 0, 0.85);
                      display: flex;
                      padding-left: 50px;
                      margin-top: 2px;
                    "
                    v-show="item.spec !== ''"
                  >
                    <span
                      style="
                        color: rgba(0, 0, 0, 0.65);
                        font-size: 14px;
                        width: 70px;
                      "
                      >Spec.</span
                    >
                    {{ item.spec }} {{ item.specUnit }}
                  </div>
                </div>
              </div>
            </div>
          </el-card>
          <!-- <el-card style="margin-top: 24px">
            <div
              style="
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: flex-end;
                justify-content: space-between;
                padding: 12px 12px;
                font-size: 16px;
                font-weight: bold;
                border-bottom: 1px solid #e0e0e0;
                box-sizing: border-box;
              "
            >
              Additional Info<el-button
                type="primary"
                size="small"
                icon="el-icon-edit"
                circle
                @click="active = 3"
              ></el-button>
            </div>
            <div
              style="
                width: 100%;
                padding: 12px 12px;
                box-sizing: border-box;
                position: relative;
              "
            >
              <div
                style="
                  font-size: 14px;
                  text-align: left;
                  color: rgba(0, 0, 0, 0.85);
                  display: flex;
                "
              >
                <span
                  style="
                    color: rgba(0, 0, 0, 0.65);
                    font-size: 14px;
                    width: 85px;
                  "
                  >Packing Method: </span
                >{{ packData.addInfo.packaged ? "打包" : "不打包" }}
              </div>
              <div
                style="
                  font-size: 14px;
                  text-align: left;
                  margin-top: 4px;
                  display: flex;
                  color: rgba(0, 0, 0, 0.85);
                "
              >
                <span
                  style="
                    color: rgba(0, 0, 0, 0.65);
                    font-size: 14px;
                    width: 98px;
                  "
                  >Insurance Fee</span
                >
                $ {{ packData.addInfo.insuranceFee }}
              </div>
              <div
                style="
                  font-size: 14px;
                  text-align: left;
                  margin-top: 4px;
                  display: flex;
                  color: rgba(0, 0, 0, 0.85);
                  word-wrap: break-word;
                "
              >
                <span
                  style="
                    color: rgba(0, 0, 0, 0.65);
                    font-size: 14px;
                    width: 60px;
                  "
                  >Remark</span
                >
                {{ packData.addInfo.remark }}
              </div>
            </div>
          </el-card> -->
          <el-card style="margin-top: 24px">
            <div
              style="
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: flex-end;
                justify-content: space-between;
                padding: 12px 12px;
                font-size: 16px;
                font-weight: bold;
                border-bottom: 1px solid #e0e0e0;
                box-sizing: border-box;
              "
            >
              <!-- Estimate Total: $ {{ packData.totalFee }} -->
              Confirm
            </div>

            <div
              style="
                width: 100%;
                padding: 12px 12px;
                box-sizing: border-box;
                position: relative;
              "
            >
              <div
                style="
                  font-size: 15px;
                  text-align: left;
                  font-weight: bold;
                  margin-top: 8px;
                  display: flex;
                  color: rgba(0, 0, 0, 0.85);
                "
              >
                Your contact info
              </div>
              <div
                v-show="
                  shipFrom === 'Brother58 Address' &&
                  userContact.phone.length > 0
                "
                style="
                  font-size: 14px;
                  text-align: left;
                  color: rgba(0, 0, 0, 0.85);
                  display: flex;
                "
              >
                <span
                  style="
                    color: rgba(0, 0, 0, 0.65);
                    font-size: 14px;
                    width: 100px;
                  "
                  >Phone</span
                >
                {{
                  `${userContact.phone.slice(0, 3)}-${userContact.phone.slice(
                    3,
                    6
                  )}-${userContact.phone.slice(6, 10)}`
                }}
              </div>
              <div
                v-show="
                  shipFrom === 'Brother58 Address' &&
                  userContact.email.length > 0
                "
                style="
                  font-size: 14px;
                  text-align: left;
                  color: rgba(0, 0, 0, 0.85);
                  display: flex;
                "
              >
                <span
                  style="
                    color: rgba(0, 0, 0, 0.65);
                    font-size: 14px;
                    width: 100px;
                  "
                  >Email</span
                >
                {{ userContact.email }}
              </div>
              <div
                v-show="shipFrom === 'Customize Address'"
                style="
                  font-size: 14px;
                  text-align: left;
                  color: rgba(0, 0, 0, 0.85);
                  display: flex;
                "
              >
                <span
                  style="
                    color: rgba(0, 0, 0, 0.65);
                    font-size: 14px;
                    width: 100px;
                  "
                  >Phone</span
                >
                {{
                  `${customSendAddress.phone.slice(
                    0,
                    3
                  )}-${customSendAddress.phone.slice(
                    3,
                    6
                  )}-${customSendAddress.phone.slice(6, 10)}`
                }}
              </div>
              <!-- <div
                style="
                  font-size: 14px;
                  text-align: left;
                  color: rgba(0, 0, 0, 0.85);
                  display: flex;
                "
              >
                <span
                  style="
                    color: rgba(0, 0, 0, 0.65);
                    font-size: 14px;
                    width: 100px;
                  "
                  >Shipping Fee</span
                >
                $ {{ packData.shippingFee }}
              </div>
              <div
                style="
                  font-size: 14px;
                  text-align: left;
                  margin-top: 4px;
                  display: flex;
                  color: rgba(0, 0, 0, 0.85);
                "
              >
                <span
                  style="
                    color: rgba(0, 0, 0, 0.65);
                    font-size: 14px;
                    width: 100px;
                  "
                  >Tax</span
                >
                $ {{ packData.tax }}
              </div>
              <div
                style="
                  font-size: 14px;
                  text-align: left;
                  margin-top: 4px;
                  display: flex;
                  color: rgba(0, 0, 0, 0.85);
                "
              >
                <span
                  style="
                    color: rgba(0, 0, 0, 0.65);
                    font-size: 14px;
                    width: 100px;
                  "
                  >Insurance</span
                >
                $ {{ packData.addInfo.insuranceFee }}
              </div>
              <div
                style="
                  font-size: 14px;
                  text-align: left;
                  margin-top: 4px;
                  display: flex;
                  color: rgba(0, 0, 0, 0.85);
                "
              >
                <span
                  style="
                    color: rgba(0, 0, 0, 0.65);
                    font-size: 14px;
                    width: 100px;
                  "
                  >Packing Method: </span
                >{{ packData.addInfo.packaged ? "打包" : "不打包" }}
              </div> -->
              <div
                style="
                  font-size: 14px;
                  text-align: left;
                  margin-top: 24px;
                  display: flex;
                  color: rgba(0, 0, 0, 0.65);
                "
              >
                We will contact you as soon as possible after your submission.
              </div>
            </div>
            <div
              style="
                width: 100%;
                display: flex;
                flex-direction: row;
                padding: 4px 12px 4px 12px;
                box-sizing: border-box;
              "
            >
              <el-button type="info" plain v-on:click="cancelOrder"
                >Cancel</el-button
              >
              <el-button
                type="success"
                icon="el-icon-success"
                v-on:click="toSubmit"
                plain
                >Submit</el-button
              >
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <div v-show="orderSuccess" class="order-success">
      <div class="success-info">
        <div class="success-image">
          <h2>On the way ...</h2>
        </div>
        <div class="success-content">
          <div>
            <div
              style="
                font-size: 20px;
                font-family: 'Trebuchet MS', 'Lucida Sans Unicode',
                  'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
              "
            >
              - Thank you! -
            </div>
            <div
              style="
                font-size: 20px;
                margin-top: 16px;
                font-family: 'Trebuchet MS', 'Lucida Sans Unicode',
                  'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
              "
            >
              We received your shipping request
            </div>
            <div
              style="
                font-size: 20px;
                margin-top: 16px;
                font-family: 'Trebuchet MS', 'Lucida Sans Unicode',
                  'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
              "
            >
              Your shipping # is: <span>{{ confirmShippingNo }}</span>
            </div>
            <div
              style="
                font-size: 20px;
                margin-top: 16px;
                font-family: 'Trebuchet MS', 'Lucida Sans Unicode',
                  'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
              "
            >
              We will contact you shortly, thanks for your patience.
            </div>
            <div
              style="
                font-size: 20px;
                margin-top: 16px;
                font-family: 'Trebuchet MS', 'Lucida Sans Unicode',
                  'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
              "
            >
              Make sure to send your package to Brother 58, or we can pickup it at your location.
            </div>
            <div
              style="
                font-size: 20px;
                margin-top: 16px;
                font-family: 'Trebuchet MS', 'Lucida Sans Unicode',
                  'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
              "
            >
              Address: {{ selectedBrother58Store.addressStr }}
            </div>
          </div>
          <div>
            <div
              style="
                font-size: 20px;
                margin-top: 16px;
                font-family: 'Trebuchet MS', 'Lucida Sans Unicode',
                  'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
              "
            >
              Go to <a href="https://brother58.studiossolution.com">brother58.studiossolution.com</a> to
              manage your shippings.
            </div>
          </div>
          <div style="padding-bottom: 56px">
            <!-- <div style="font-size:20px;margin-top:9vh;text-decoration:underline;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;cursor:pointer; font-weight: 900" @click="finishShipping">Finish</div> -->
            <el-button
              type="primary"
              round
              @click="finishShipping"
              style="margin-top: 5vh"
              >Finish</el-button
            >
            <div
              style="
                font-size: 14px;
                font-weight: bold;
                margin-top: 18px;
                font-family: 'Trebuchet MS', 'Lucida Sans Unicode',
                  'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
              "
            >
              - OR -
            </div>
            <!-- <div style="font-size:20px;margin-top:12px;text-decoration:underline;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;cursor:pointer; font-weight: 900" @click="restartShipping">Start A New Shipping</div> -->
            <el-button
              type="primary"
              round
              plain
              @click="restartShipping"
              style="margin-top: 12px"
              >Start A New Shipping</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div v-show="orderFail" class="order-success">
      <div class="fail-info">
        <div class="success-image">
          <h2>Errr ...</h2>
        </div>
        <div class="success-content">
          <div>
            <div
              style="
                font-size: 20px;
                font-family: 'Trebuchet MS', 'Lucida Sans Unicode',
                  'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
              "
            >
              - Sorry... -
            </div>
            <div
              style="
                font-size: 20px;
                margin-top: 16px;
                font-family: 'Trebuchet MS', 'Lucida Sans Unicode',
                  'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
              "
            >
              Something strange just happened
            </div>
            <div
              style="
                font-size: 20px;
                margin-top: 16px;
                font-family: 'Trebuchet MS', 'Lucida Sans Unicode',
                  'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
              "
            >
              We will solve the problem as soon as possible
            </div>
            <div
              style="
                font-size: 20px;
                margin-top: 16px;
                font-family: 'Trebuchet MS', 'Lucida Sans Unicode',
                  'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
              "
            >
              Before that
            </div>
          </div>
          <div>
            <div
              style="
                font-size: 20px;
                margin-top: 16px;
                font-family: 'Trebuchet MS', 'Lucida Sans Unicode',
                  'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
              "
            >
              You may try to submit it again
            </div>
          </div>
          <div style="padding-bottom: 56px">
            <!-- <div style="font-size:20px;margin-top:8vh;text-decoration:underline;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;cursor:pointer" @click="toSubmit">Try Again</div> -->
            <el-button
              type="primary"
              round
              @click="toSubmit"
              style="margin-top: 5vh"
              >Try Again</el-button
            >
            <div
              style="
                font-size: 14px;
                font-weight: bold;
                margin-top: 18px;
                font-family: 'Trebuchet MS', 'Lucida Sans Unicode',
                  'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
              "
            >
              - OR -
            </div>
            <!-- <div style="font-size:20px;margin-top:12px;text-decoration:underline;font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;cursor:pointer" @click="closeFail">Quit</div> -->
            <el-button
              type="primary"
              round
              plain
              @click="closeFail"
              style="margin-top: 12px"
              >Quit</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showAddressBook"
      style="
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1000;
        overflow-y: auto;
        oveflow-x: hidden;
      "
    >
      <div>
        <address-book
          v-on:select-address="selectAddress($event)"
          v-on:close-address-book="showAddressBook = false"
          :user="user"
          :selector="true"
        >
        </address-book>
      </div>
    </div>
  </div>
</template>

<script src="https://ajax.googleapis.com/ajax/libs/webfont/1.4.7/webfont.js" type="text/javascript"></script>
<script type="text/javascript">
WebFont.load({
  google: {
    families: [
      "Montserrat:100,100italic,200,200italic,300,300italic,400,400italic,500,500italic,600,600italic,700,700italic,800,800italic,900,900italic",
    ],
  },
});
</script>
<script>
/* eslint-disable handle-callback-err */

import { ChinaRegion } from "../../public/js/ChinaRegion";
import { postShippingOrder, calcShippingFee } from "../../public/js/shipping";
import AddressBook from "@/components/AddressBook";
// import vgm from '@/main'

function getInitData(userGroup) {
  return {
    center: {
      lat: 41.962542,
      lng: -88.232324,
    },
    userPosition: null,
    zoom: 9,

    selectStore: true,
    selectedStoreIndex: 0,

    newForm: true,
    active: 0,
    orderSuccess: false,
    orderFail: false,
    shipFrom: "Brother58 Address",
    hasUserContact: false,
    userContact: {
      email: "",
      phone: "",
    },
    customSendAddress: {
      name: "",
      phone: "",
      address1: "",
      address2: "",
      city: "Chicago",
      state: "IL",
      postal: "",
      country: "United States",
    },
    receiveInfo: {
      name: "",
      phone: "",
      ID: "",
      addressInfo: "",
      district: "",
      city: "",
      province: "",
      postal: "",
      country: "中国",
    },
    selectedRegion: [],
    packDetail: {
      items: [
        {
          category: "",
          key: Date.now(),
          name: "",
          qty: "",
          price: "",
          spec: "",
          specUnit: "克 g",
          weight: "",
        },
      ],
    },
    addInfo: {
      packing: "是 Yes (包税模式运费较高，B2C运费无影响)",
      packingFee: 0,
      insurance: "Free（免费），如包裹丢失最高赔付$100",
      insuranceFee: 0,
      shippingMethod: "b2c",
      packaged: true,
      remark: "",
    },
    saveToAddressBook: {
      alias: "",
      save: false,
      docId: "",
    },
    showAddressBook: false,
    rules: {
      name: [{ required: true, message: "Please input name", trigger: "blur" }],
      phone: [
        {
          required: true,
          message: "Please input phone number",
          trigger: "blur",
        },
        {
          type: "string",
          pattern: /^[0-9]*$/,
          message: "Phone number should be digits only",
          triger: "change",
        },
        {
          min: 10,
          max: 10,
          message: "Phone number should be 10 digits",
          triger: "change",
        },
      ],
      address1: [
        { required: true, message: "Please input address", trigger: "blur" },
      ],
      address2: [{ required: false }],
      city: [{ required: true, message: "Please input city", trigger: "blur" }],
      state: [
        { required: true, message: "Please input state", trigger: "blur" },
      ],
      postal: [
        {
          required: true,
          message: "Please input postal code",
          trigger: "blur",
        },
        {
          type: "string",
          pattern: /^[0-9]*$/,
          message: "Postal code should be digits only",
          triger: "change",
        },
        {
          min: 5,
          max: 5,
          message: "Postal code should be 5 digits",
          triger: "change",
        },
      ],
    },
    rulesReceiver: {
      name: [{ required: true, message: "Please input name", trigger: "blur" }],
      phone: [
        {
          required: true,
          message: "Please input phone number",
          trigger: "blur",
        },
        {
          type: "string",
          pattern: /^[0-9]*$/,
          message: "Phone number should be digits only",
          triger: "change",
        },
        {
          min: 11,
          max: 11,
          message: "Phone number should be 11 digits",
          triger: "change",
        },
      ],
      addressInfo: [
        { required: true, message: "Please input address", trigger: "blur" },
      ],
      province: [
        { required: true, message: "Please select region", trigger: "change" },
      ],
      postal: [
        {
          required: true,
          message: "Please input postal code",
          trigger: "blur",
        },
        {
          type: "string",
          pattern: /^[0-9]*$/,
          message: "Postal code should be digits only",
          triger: "change",
        },
        {
          min: 6,
          max: 6,
          message: "Postal code should be 6 digits",
          triger: "change",
        },
      ],
      ID: [
        {
          required: true,
          message: "Please input reveiver's ID",
          trigger: "blur",
        },
        {
          type: "string",
          pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)/,
          message: "Please enter valid ID number",
          triger: "blur",
        },
      ],
    },
    rulesItems: {
      weight: [
        {
          required: true,
          message: "Please estimate package weight(lb)",
          trigger: "blur",
        },
        {
          type: "string",
          validator: validateWeight,
          message: "Weight should be a number greater than 0",
          triger: "change",
        },
      ],
    },
    rulesAddInfo: {
      packing: [
        {
          required: true,
          message: "Please select a packing",
          trigger: "change",
        },
      ],
      insurance: [
        {
          required: true,
          message: "Please select an insurance for your package",
          trigger: "change",
        },
      ],
      remark: [{ required: false }],
    },
    locationOption: ChinaRegion,
    categoryOption: [
      {
        value: "Health_Supplement",
        label: "Health Supplement",
      },
      {
        value: "Baby_Formula",
        label: "Baby Formula (Milk Powder)",
      },
      {
        value: "Baby_Care",
        label: "Baby_Care",
      },
      {
        value: "Clothes",
        label: "Clothes",
      },
      {
        value: "Daily_Necessities",
        label: "Daily Necessities",
      },
      {
        value: "Shoes",
        label: "Shoes",
      },
      {
        value: "Bag",
        label: "Bag",
      },
      {
        value: "Electronics",
        label: "Electronics",
      },
      {
        value: "Accessories",
        label: "Accessories",
      },
      {
        value: "Cosmetic",
        label: "Cosmetic",
      },
      {
        value: "Watch",
        label: "Watch",
      },
      {
        value: "Other",
        label: "Other",
      },
    ],
    categoryRule: {
      Health_Supplement: true,
      Baby_Formula: true,
      Baby_Care: false,
      Clothes: false,
      Daily_Necessities: false,
      Shoes: false,
      Bag: false,
      Electronics: false,
      Accessories: false,
      Cosmetic: false,
      Watch: false,
      other: false,
    },
    warningTxt: "",
    confirmShippingNo: "",
  };
}

export default {
  name: "HomeForm",
  props: ["user", "stores"],
  data() {
    return getInitData(this.user.userGroup);
  },
  timers: {
    validateWatcher: {
      time: 1000,
      autostart: true,
      repeat: true,
      immediate: true,
    },
  },
  methods: {
    selectMarker: function (index) {
      this.selectedStoreIndex = index;
    },
    selectAddress: function (address) {
      this.receiveInfo.name = address.name;
      this.receiveInfo.phone = address.phone;
      this.receiveInfo.ID = address.ID;
      this.receiveInfo.addressInfo = address.addressInfo;
      this.receiveInfo.district = address.district;
      this.receiveInfo.city = address.city;
      this.receiveInfo.province = address.province;
      this.receiveInfo.postal = address.postal;
      this.receiveInfo.country = address.country;

      this.selectedRegion = [address.province, address.city, address.district];

      this.showAddressBook = false;
    },
    closeFail: function () {
      this.orderFail = false;
    },
    toStep1: function () {
      this.active = 0;
    },
    toStep2: function () {
      if (this.shipFrom === "Brother58 Address") {
        // revalidate the user contact
        let hasUserContact = false;
        this.addInfo.remark = "";

        // butify the phone string to nanp format
        if (this.userContact.phone.length === 10) {
          let nanpFormat =
            this.userContact.phone.slice(0, 3) +
            "-" +
            this.userContact.phone.slice(3, 6) +
            "-" +
            this.userContact.phone.slice(6);
          // console.log(nanpFormat);
          hasUserContact = true;
        }
        if (validateEmail(this.userContact.email)) {
          // this.addInfo.remark =
          //   this.addInfo.remark + this.userContact.email + "\n";
          hasUserContact = true;
        }

        if (hasUserContact) {
          this.active = 1;
        } else {
          this.$message.error(
            "We need at least one valid method for contact you."
          );
        }
      } else {
        this.$refs["step1Form"].validate((valid) => {
          // CHANGE TRUE TO 'valid' for validating
          // valid = true
          if (valid) {
            this.active = 1;
          } else {
            // console.log("error submit!!");
          }
        });
      }
    },
    toStep3: function () {
      this.$refs["step2Form"].validate((valid) => {
        // valid = true
        if (valid) {
          this.active = 2;
        } else {
          // console.log("error submit!!");
        }
      });
    },
    toStep4: function () {
      this.$refs["step3Form"].validate((valid) => {
        // valid = true
        if (valid) {
          var items = this.packDetail.items;
          var categoryRule = this.categoryRule;
          for (var i = 0; i < items.length; i++) {
            if (items[i].category === "") {
              this.warningTxt =
                "Please select an item category for item " + (i + 1);
              return;
            }
            if (items[i].name === "") {
              this.warningTxt = "Please input item name for item " + (i + 1);
              return;
            }
            if (items[i].qty === "") {
              this.warningTxt =
                "Please input item quantity for item " + (i + 1);
              return;
            }
            if (
              !(!isNaN(parseInt(items[i].qty)) && parseInt(items[i].qty) > 0)
            ) {
              this.warningTxt =
                "Quantity should be an integer greater than 0 for item " +
                (i + 1);
              return;
            }
            if (items[i].price === "") {
              this.warningTxt = "Please input item price for item " + (i + 1);
              return;
            }
            if (
              !(
                !isNaN(parseFloat(items[i].price)) &&
                parseFloat(items[i].price) >= 0
              )
            ) {
              this.warningTxt =
                "Price should be a number greater or equal to 0 for item " +
                (i + 1);
              return;
            }
            if (items[i].weight === "") {
              this.warningTxt =
                "Please input item total weight for item " + (i + 1);
              return;
            }
            if (
              !(
                !isNaN(parseFloat(items[i].weight)) &&
                parseFloat(items[i].weight) >= 0
              )
            ) {
              this.warningTxt =
                "Weight should be a number greater or equal to 0 for item " +
                (i + 1);
              return;
            }
            if (categoryRule[items[i].category] && items[i].spec === "") {
              this.warningTxt = "Please input item Spec. for item " + (i + 1);
              return;
            }
            if (categoryRule[items[i].category] && items[i].spec === "") {
              if (
                !(
                  !isNaN(parseFloat(items[i].spec)) &&
                  parseFloat(items[i].spec) > 0
                )
              ) {
                this.warningTxt =
                  "Spec. should be a number greater than 0 for item " + (i + 1);
                return;
              }
            }
            if (categoryRule[items[i].category] && items[i].specUnit === "") {
              this.warningTxt =
                "Please select item Spec. unit for item " + (i + 1);
              return;
            }
          }
          this.warningTxt = "";
          this.active = 4; // step 4 is skippid, modify the number to 3 for including skip 4
        } else {
          // console.log("error submit!!");
        }
      });
    },
    toStep5: function () {
      this.$refs["step3Form"].validate((valid) => {
        // valid = true
        if (valid) {
          this.active = 4;
        } else {
          // console.log("error submit!!");
        }
      });
    },
    addItem: function () {
      if (this.packDetail.items.length < 10) {
        this.packDetail.items.push({
          category: "",
          key: Date.now(),
          name: "",
          qty: "",
          price: "",
          spec: "",
          specUnit: "克 g",
          weight: "",
        });
      } else {
        this.$notify.info({
          title: "提示 Tips",
          message:
            "</p>单包裹种类上限为10种</p><p>Limited to 10 items in a package</p>",
          dangerouslyUseHTMLString: true,
        });
      }
    },
    deleteItem: function (item) {
      var index = this.packDetail.items.indexOf(item);
      if (index !== -1 && this.packDetail.items.length > 1) {
        this.packDetail.items.splice(index, 1);
      } else if (index !== -1 && this.packDetail.items.length === 1) {
        this.$notify.info({
          title: "提示 Tips",
          message:
            "</p>至少包含一个物品</p><p>At least one item in a package</p>",
          dangerouslyUseHTMLString: true,
        });
      }
    },
    shippingMethod: function (val) {
      this.addInfo.shippingMethod = val;
    },
    selectPacking: function (packing) {
      if (packing) {
        this.addInfo.packing = "是 Yes (包税模式运费较高，B2C运费无影响)";
        this.addInfo.packaged = true;
      } else {
        this.addInfo.packing = "否 No (包税模式运费较低，B2C运费无影响)";
        this.addInfo.packaged = false;
      }
    },
    insuranceFee: function (insuranceFee) {
      if (insuranceFee === 0) {
        this.addInfo.insurance = "Free（免费），如包裹丢失最高赔付$100";
        this.addInfo.insuranceFee = insuranceFee.toFixed(2);
      } else if (insuranceFee === 5) {
        this.addInfo.insurance = "$5，如包裹丢失最高赔付$200";
        this.addInfo.insuranceFee = insuranceFee.toFixed(2);
      } else if (insuranceFee === 10) {
        this.addInfo.insurance = "$10，如包裹丢失最高赔付$300";
        this.addInfo.insuranceFee = insuranceFee.toFixed(2);
      } else if (insuranceFee === 15) {
        this.addInfo.insurance = "$15，如包裹丢失最高赔付$400";
        this.addInfo.insuranceFee = insuranceFee.toFixed(2);
      }
    },
    b2cTotal: function () {
      let total =
        parseFloat(this.shippingFee.b2c) +
        parseFloat(this.shippingFee.tax) +
        parseFloat(this.addInfo.insuranceFee);
      return total.toFixed(2);
    },
    noTaxTotal: function () {
      let total = 0;
      if (this.addInfo.packaged) {
        total =
          parseFloat(this.shippingFee.packaged) +
          parseFloat(this.addInfo.insuranceFee);
      } else {
        total =
          parseFloat(this.shippingFee.unpackaged) +
          parseFloat(this.addInfo.insuranceFee);
      }
      return total.toFixed(2);
    },
    cancelOrder: function () {
      this.$confirm(
        "This will permanently delete what you entered. Confirm to cancel your order?",
        "Warning",
        {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.$emit("to-homepage");
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    toSubmit: function () {
      // submit order to firebase
      let order = {};
      order = this.packData;
      order.stamp = Date.now();
      order.date = getLocalDate(order.stamp);
      order.inStore = true;
      order.owner = this.user.uid;
      order.email = this.user.email;
      order.status = "Unpaid";
      order.saveToAddressBook = this.saveToAddressBook;
      postShippingOrder(order)
        .then((orderData) => {
          // console.log("Success post the order =>", orderData);
          this.orderSuccess = true;
          this.orderFail = false;
          this.confirmShippingNo = orderData.shippingNo;
        })
        .catch((err) => {
          // console.log("Unable to post order =>", err);
          this.orderFail = true;
          this.orderSuccess = false;
        });
    },
    restartShipping: function () {
      Object.assign(this.$data, getInitData(this.user.userGroup));
    },
    finishShipping: function () {
      this.$emit("to-homepage");
      Object.assign(this.$data, getInitData(this.user.userGroup));
    },
    validateWatcher: function () {
      if (this.newForm) {
        this.$refs["step1Form"].clearValidate();
        this.$refs["step2Form"].resetFields();
        this.$refs["step3Form"].resetFields();
        this.newForm = false;
        // console.log("clear validation");
      }
    },
    setUserPosition(position) {
      this.userPosition = position;
    },
  },
  computed: {
    selectedBrother58Store: function () {
      if (this.stores && this.stores.length > 0) {
        return JSON.parse(JSON.stringify(this.stores[this.selectedStoreIndex]));
      } else {
        return {};
      }
    },
    packData: function () {
      var packData = {};

      // Add store tag
      packData.storeGroup = this.selectedBrother58Store.storeGroup
        ? this.selectedBrother58Store.storeGroup
        : "NOT_ASSIGNED";
      packData.longCode = this.selectedBrother58Store.longCode
        ? this.selectedBrother58Store.longCode
        : "";

      // Shipping From Address
      if (this.shipFrom === "Brother58 Address") {
        let shipAddress = {
          name: "Please use store name",
          phone: "Please use store phone",
          address1: "Please use store address",
          address2: "",
          city: "Chicago",
          state: "IL",
          postal: "60616",
          country: "United States",
        };
        if (
          this.selectedBrother58Store &&
          this.selectedBrother58Store.shippingAddress
        ) {
          shipAddress = this.selectedBrother58Store.shippingAddress;
        }
        packData.shipFrom = shipAddress;
      } else {
        packData.shipFrom = this.customSendAddress;
      }

      // Shipping To Address
      packData.shipTo = this.receiveInfo;

      // Package Info
      var packDetail = this.packDetail;
      var items = packDetail.items;
      var categoryRule = this.categoryRule;
      for (var i = 0; i < items.length; i++) {
        for (var category in categoryRule) {
          if (items[i].category === category) {
            if (!categoryRule[category]) {
              items[i].spec = "";
              items[i].specUnit = "";
            }
          }
        }
      }
      packDetail.items = items;
      packData.packDetail = packDetail;

      let fees = this.shippingFee;

      if (this.addInfo.shippingMethod === "b2c") {
        packData.tax = fees.tax;
        packData.shippingFee = fees.b2c;
      } else {
        packData.tax = "0.00";
        packData.shippingFee = this.addInfo.packaged
          ? fees.packaged
          : fees.packaged;
      }

      var totalFee;
      if (this.addInfo.shippingMethod === "b2c") {
        totalFee = this.b2cTotal();
      } else if (this.addInfo.shippingMethod === "noTax") {
        totalFee = this.noTaxTotal();
      } else {
        totalFee = "Invalid shipping method";
      }
      packData.totalFee = totalFee;

      // !IMPORTANT: set the totalFee to constant 0 for Brother 58 Project
      packData.totalFee = "0.00";

      // Additional Info
      packData.addInfo = this.addInfo;
      packData.addInfo.deliveryStatus = "待收件";
      packData.userContact = {
        phone: "",
        email: ""
      }
      if (this.shipFrom === "Brother58 Address") {
        packData.userContact.email = this.userContact.email;
        packData.userContact.phone = `${this.userContact.phone.slice(0, 3)}-${this.userContact.phone.slice(3, 6)}-${this.userContact.phone.slice(6, 10)}`;

      } else {
        packData.userContact.phone = `${this.customSendAddress.phone.slice(0, 3)}-${this.customSendAddress.phone.slice(3, 6)}-${this.customSendAddress.phone.slice(6, 10)}`;
      }
      return packData;
    },
    shippingFee: function () {
      var receiveProvince = this.receiveInfo.province;
      return calcShippingFee(this.packDetail.items, receiveProvince);
    },
  },
  watch: {
    selectedRegion: function () {
      this.receiveInfo.province = this.selectedRegion[0];
      this.receiveInfo.city = this.selectedRegion[1];
      this.receiveInfo.district = this.selectedRegion[2];
    },
  },
  components: {
    AddressBook, //, vgm
  },
};
var validateWeight = (rule, value, callBack) => {
  if (parseFloat(value) <= 0) {
    return callBack(new Error("Weight should be a number greater than 0"));
  } else {
    callBack();
  }
};

function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
function getLocalDate(stamp) {
  let dateObj = new Date(stamp);
  let year = dateObj.getFullYear();
  let month = String(dateObj.getMonth() + 1);
  if (month.length < 2) {
    month = "0" + month;
  }
  let date = String(dateObj.getDate());
  if (date.length < 2) {
    date = "0" + date;
  }
  return year + "-" + month + "-" + date;
}
</script>

<style scoped>
p {
  text-align: left;
}
h2 {
  font-size: 35pt;
}
.el-form-item {
  display: flex;
  flex-direction: column;
}
.el-form-item__label {
  position: relative;
  text-align: left;
}
.font-bold {
  font-weight: bold;
}
.form-header {
  padding: 0 20px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
}
.form-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: medium;
}
.back-home {
  font-size: 18px;
  color: whitesmoke;
  font-weight: normal;
  cursor: pointer;
}
.studio-s {
  margin-left: 4px;
  font-size: medium;
  color: #c62828;
  text-decoration: none;
}
.form-main {
  padding: 64px 120px;
}
.step1 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.from-shop {
  width: 48%;
}
.from-home {
  width: 48%;
}
.step2 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
}
.ship-to {
  width: 48%;
  margin: auto;
}
.step3 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
}
.pack-detail {
  width: 48%;
  margin: auto;
}
.specSelect {
  width: 200px;
}
.step4 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
}
.add-info {
  width: 48%;
  margin: auto;
}
.step5 {
  padding-top: 56px;
  margin: auto;
  width: 90%;
}
.confirm-info {
  width: 48%;
  margin: auto;
}
.order-success {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  background-color: rgba(77, 77, 77, 0.4);
  z-index: 1001;
  animation: showConfirm 0.4s ease;
}
/* .success-info {
  color: rgba(0, 0, 0, 0.6);
  width: 800px;
  height: 70vh;
  margin: auto;
  background-image: url(../../public/images/yunda-b-6.jpg);
  background-position: left top;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 28px 50px -25px #494949;
  overflow: auto;
} */
/* .fail-info {
  color: rgba(0, 0, 0, 0.6);
  width: 800px;
  height: 70vh;
  margin: auto;
  background-image: url(../../public/images/yunda-back.jpg);
  background-position: left top;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 28px 50px -25px #494949;
  overflow: auto;
} */
/* .success-image {
  width: 780px;
  height: 18vh;
  border-radius: 5PX 5px 0 0;
  color: rgba(49, 49, 49, 0.2);
  font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  display: flex;
  align-items:flex-start;
  justify-content: flex-end;
}
.success-content {
  width: 100%;
  height: 49.5vh;
  border-radius: 0 0 5px 5px;
} */
@keyframes showConfirm {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media (max-width: 1440px) {
  .step1 {
    width: 95%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .step2 {
    margin: auto;
    width: 95%;
  }
  .step3 {
    margin: auto;
    width: 95%;
  }
  .step4 {
    margin: auto;
    width: 95%;
  }
  .step5 {
    margin: auto;
    width: 95%;
  }
  .from-shop {
    width: 60%;
  }
  .from-home {
    margin-top: 16px;
    width: 60%;
  }
  .ship-to {
    width: 60%;
  }
  .pack-detail {
    width: 60%;
  }
  .add-info {
    width: 60%;
  }
  .confirm-info {
    width: 60%;
  }
  .el-card__body {
    padding: 20px 4px;
  }
}
@media (max-width: 1024px) {
  .form-main {
    padding: 24px 12px;
    font-size: small;
  }
  .step1 {
    width: 95%;
    margin: auto;
    display: flex;
    flex-direction: column;
    padding-top: 24px;
  }
  .step2 {
    padding-top: 24px;
    margin: auto;
    width: 95%;
  }
  .step3 {
    padding-top: 24px;
    margin: auto;
    width: 95%;
  }
  .step4 {
    padding-top: 24px;
    margin: auto;
    width: 95%;
  }
  .step5 {
    padding-top: 24px;
    margin: auto;
    width: 95%;
  }
  .from-shop {
    width: 100%;
  }
  .from-home {
    margin-top: 16px;
    width: 100%;
  }
  .ship-to {
    width: 100%;
  }
  .pack-detail {
    width: 100%;
  }
  .add-info {
    width: 100%;
  }
  .confirm-info {
    width: 100%;
  }
  .el-card__body {
    padding: 20px 4px;
  }
}
@media (max-width: 812px) {
  .specSelect {
    width: 80px;
  }
  .el-message-box {
    width: 300px;
  }
  .el-step__title {
    font-size: 14px;
  }
  /* .success-info {
  color: rgba(0, 0, 0, 0.6);
  width: 95%;
  height: 95vh;
  margin: auto;
  background:url(../../public/images/yunda-b-7.jpg);
  background-size: right;
  background-position: left top;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 20px;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 28px 50px -25px #494949;
  display: flex;
  flex-direction: column;
  overflow: auto;
} */
  /* .success-image {
  width: 100%;
  border-radius: 5PX 5px 0 0;
  color: rgba(49, 49, 49, 0.2);
  font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  display: flex;
  align-items:flex-start;
  justify-content: flex-end;
}
.success-content {
  width: 100%;
  border-radius: 0 0 5px 5px;
} */
}
</style>
